import { render, staticRenderFns } from "./ModalPerVoucher.vue?vue&type=template&id=52338948&"
import script from "./ModalPerVoucher.vue?vue&type=script&lang=js&"
export * from "./ModalPerVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports